import {AnalysisStatusEnum} from "./analysis-status";
import {GetAnalysisResponseDto, GetAnalysisTyreResponseDto} from "../dto/get-analysis-response-dto";
import {SpareTyreResultEnum} from "./spare-tyre-result-enum";
import {AnalysisResponseDto} from "../dto/analysis-response-dto";
import {PostAnalysisResponseDto, PostAnalysisTyreAnalysisResponseDto} from "../dto/post-analysis-response-dto";

export class Analysis {
  id?: number;
  uuid?:string;
  status: AnalysisStatusEnum = AnalysisStatusEnum.STARTED;
  referenceTyres: TyreAnalysis[] = [];
  wearTyres: TyreAnalysis[] = [];
  postcode?: AnalysisPostcode;
  vehicleMileage?: number;
  spareTyreResult?: SpareTyreResult;
  vinResult?: VinResult;

  constructor(dto?: GetAnalysisResponseDto | AnalysisResponseDto) {
    if (dto && "id" in dto) {
      this.id = dto.id;
    } else if (dto) {
      this.id = dto.analysisId;
      this.spareTyreResult = dto.spareTyreResult;
      this.status = dto.status;
      this.referenceTyres = dto.referenceTyres.map(rt => new TyreAnalysis(rt));
      this.wearTyres = dto.wearTyres.map(wt => new TyreAnalysis(wt));
    }
  }

  public static create(analysisResponseDto: PostAnalysisResponseDto) {
    const analysis = new Analysis();
    if (analysisResponseDto) {
      analysis.id = analysisResponseDto.id;
      analysis.uuid = analysisResponseDto.analysisUuid;
      analysis.status = analysisResponseDto.status;
      analysis.referenceTyres = analysisResponseDto.referenceTyres.map(rt => TyreAnalysis.create(rt));
      analysis.wearTyres = analysisResponseDto.wearTyres.map(wt => TyreAnalysis.create(wt));
    }
    return analysis;
  }
}

export class TyreAnalysis {
  id?: number;
  status: AnalysisStatusEnum = AnalysisStatusEnum.STARTED;
  position?: number;
  outside: boolean = true;
  uploadUrl?: {
    url: string;
    fileName: string;
  }

  constructor(dto?: GetAnalysisTyreResponseDto) {
    if (dto) {
      this.id = dto.tyreAnalysisId;
      this.status = dto.status === AnalysisStatusEnum.AI_READY ? AnalysisStatusEnum.UPLOADED : dto.status;
      this.position = dto.position;
      this.outside = dto.outside;
      this.uploadUrl = dto.uploadUrl;
    }
  }

  public static create(tyreAnalysisResponseDto: PostAnalysisTyreAnalysisResponseDto) {
    const tyreAnalysis = new TyreAnalysis();
    tyreAnalysis.id = tyreAnalysisResponseDto.id;
    tyreAnalysis.status = tyreAnalysisResponseDto.status === AnalysisStatusEnum.AI_READY ? AnalysisStatusEnum.UPLOADED : tyreAnalysisResponseDto.status;
    return tyreAnalysis;
  }
}

export interface SpareTyreResult {
    spareTyreResult: SpareTyreResultEnum | null,
    vehicleAnalysisId: number,
    status: AnalysisStatusEnum
}

export interface VinResult {
  vehicleAnalysisId: number,
  status: AnalysisStatusEnum,
  vin: string,
  uploadUrls: {
    url: string,
    fileName: string
  }[]
}

export class AnalysisPostcode {
  codePostal?: string;
  codeCommune?: string;
  nomCommune?: string;
  libelleAcheminement?: string;
}
